import { Injectable } from '@angular/core'
import { io, Socket } from 'socket.io-client'
import { uiClientsConfig } from 'admin-ui-v2-config'
import { LocalServiceService } from 'src/app/services/local-service.service'
import { NotificationService } from './notification.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationWebsocketService {
    private socket: Socket | null = null;
    private wsUrl = `wss://${uiClientsConfig.customerUrlPrefix}-admin.${uiClientsConfig.reservedUrlDomain}/system-notification`
    private userId: string | null = null;



    constructor(
        private localService: LocalServiceService,
        private notificationService: NotificationService,
    ) { }
    connectWebSocket(): void {
        this.connect()
    }
    disconnectWebSocket(): void {
        if (this.socket) {
            this.socket.disconnect()
            this.socket = null
        }
    }
    private getAccessToken() {
        const subdomain: string = window.location.hostname
            .split('.')[0]
            .split('-')[0]
        const cookies: string[] = document.cookie.split(';')

        for (let i = 0; i < cookies.length; i++) {
            const cookie: string = cookies[i].trim()

            if (cookie.includes(subdomain) && cookie.includes('access_token')) {
                let decodedCookieValue: string =
                    decodeURIComponent(cookie).split('=')[1]
                const tokenObject = JSON.parse(decodedCookieValue)

                return tokenObject.access_token
            }
        }

        return null
    }
    private connect(): void {
        const attemptConnection = () => {
            const accessToken: string | null = this.getAccessToken()

            if (!accessToken) {
                console.warn(
                    'WebsocketService: Access token not found. Retrying in 5s...',
                )
                setTimeout(attemptConnection, 5000)
                return
            }

            this.socket = io(this.wsUrl, {
                transports: ['websocket'],
                reconnection: false, // WE handle reconnection manually
                auth: {
                    token: accessToken,
                },
            })

            this.registerSocketEvents(attemptConnection) ;
        }

        attemptConnection()
    }
    private registerSocketEvents(retryFn: () => void): void {
        if (!this.socket) return

        this.socket.on('connect', () => {
            console.log('WebSocket connected')
        })

        this.socket.on('disconnect', (reason) => {
            this.socket?.removeAllListeners()
            this.socket = null

            // Reconnect after 5s
            setTimeout(retryFn, 5000)
        })

        this.socket.on('connect_error', (error) => {
            this.socket?.removeAllListeners()
            this.socket = null

            // Retry with latest token after 5s
            setTimeout(retryFn, 5000)
        })

        this.socket.on('new-system-notification', (data: any) => {
            this.handleNotification(data)
        })

    }

    private handleNotification(data: any): void {
        const currentUnreadCount = this.notificationService._totalUnreadCount.getValue() || 0;
        this.notificationService._totalUnreadCount.next(currentUnreadCount+1);
        this.notificationService._blink.next(true);
        let currentNotifications = this.notificationService._realTimeNotification.getValue() || [];
        if (currentNotifications.length >= 3) {
            currentNotifications.pop(); 
        }
        currentNotifications.unshift(data);
        this.notificationService._realTimeNotification.next(currentNotifications);
    }
}
